import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc4bc00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resultcolumn" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = {
  key: 0,
  class: "p-2"
}
const _hoisted_4 = {
  key: 1,
  class: "p-2"
}
const _hoisted_5 = {
  key: 2,
  class: "p-2"
}
const _hoisted_6 = {
  key: 3,
  class: "p-2"
}
const _hoisted_7 = { class: "p-2 resultcolumn_actions" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "button button--primary" }


import configHelper from '../../helpers/configHelper';
import { TranslatedDownload } from '../../types';


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null,
    id: null,
    year: null
  },
  emits: ["generateShareableLink"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, _toDisplayString(__props.item.downloadTyp), 1),
    (__props.item.language)
      ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(__props.item.language), 1))
      : (_openBlock(), _createElementBlock("td", _hoisted_4)),
    (__props.item.region)
      ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(__props.item.region), 1))
      : (_openBlock(), _createElementBlock("td", _hoisted_6)),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("a", {
        download: "",
        href: `${_unref(configHelper).PDA_API}/articles/${__props.year}/${__props.id}/${__props.item._id}`
      }, [
        _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('downloadFile')), 1)
      ], 8, _hoisted_8),
      _createElementVNode("button", {
        class: "button button--secondary m-l-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('generateShareableLink')))
      }, _toDisplayString(_ctx.$t('createShareLink')), 1)
    ])
  ]))
}
}

})